import { useTenancy } from "@/hooks/tenancy/use-tenancy";
import { CreditCard, X } from "lucide-react";
import { useAuth } from "@/providers/auth";
import { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { MERCHANT_LANDING_PATH } from "@/pages/merchant-processing/constants";

const STORAGE_KEY = "MERCHANT_PROCESSING_BANNER_DISMISSED";
const BAAS_STATUS = ["NOT_FOUND", "not_started"];
const CC_ACTIVE_STATUSES = [
  "APPLICATION_CREATED",
  "IDENTITY_VERIFICATION",
  "IDENTITY_VERIFICATION_SUBMITTED",
  "ACCEPT_FEES",
  "ACCEPTED_FEES",
  "ACCEPT_TERMS_AND_CONDITIONS",
  "ACCEPTED_TERMS_AND_CONDITIONS",
  "APPLICATION_SUBMITTED",
  "APPLICATION_APPROVED",
  "APPLICATION_REJECTED",
  "APPLICATION_NEEDS_INFO",
];

export function MerchantProcessingBanner() {
  const [show, setShow] = useState(false);
  const { data: tenancy } = useTenancy();
  const { user } = useAuth();
  const history = useHistory();

  useEffect(() => {
    const isOwner = user?.cognito_user_info?.UserRole === "owner";
    if (!isOwner) return;

    const dismissed = JSON.parse(localStorage.getItem(STORAGE_KEY));
    if (dismissed) return;

    const hasCCFeatureFlag = !!tenancy?.feature_flags?.credit_card_payment;
    if (!hasCCFeatureFlag) return;

    const ccStatus = tenancy?.flags?.credit_card_provider_application_status;
    if (CC_ACTIVE_STATUSES.includes(ccStatus)) return;

    // Don't show if LimitedAccountWarning is visible
    const baasWarningClosed = JSON.parse(
      localStorage.getItem("BAAS_WARNING_CLOSED"),
    );
    const limitedWarningShowing =
      !baasWarningClosed && BAAS_STATUS.includes(tenancy?.baas_status);
    if (limitedWarningShowing) return;

    setShow(true);
  }, [tenancy, user]);

  const dismiss = () => {
    setShow(false);
    localStorage.setItem(STORAGE_KEY, JSON.stringify(true));
  };

  const handleClick = () => {
    dismiss();
    history.push(MERCHANT_LANDING_PATH);
  };

  if (!show) return null;

  return (
    <div className="flex items-center rounded-md bg-blue-50 p-4 md:ml-[310px]">
      <div className="flex pl-7">
        <div className="flex-shrink-0">
          <CreditCard className="h-5 w-5 text-blue-400" aria-hidden="true" />
        </div>
        <div className="ml-3">
          <div className="text-sm text-blue-700">
            <p>
              Merchant processing is now available.{" "}
              <button
                type="button"
                onClick={handleClick}
                className="font-medium text-blue-700 underline hover:text-blue-600"
              >
                Click here
              </button>{" "}
              to learn more and start accepting card payments from your
              customers.
            </p>
          </div>
        </div>
      </div>
      <div className="ml-auto pl-3 pr-5">
        <div className="-mx-1.5 -my-1.5">
          <button
            type="button"
            className="inline-flex rounded-md bg-blue-50 p-1.5 text-blue-500 hover:bg-blue-100 focus:outline-none focus:ring-2 focus:ring-blue-600 focus:ring-offset-2 focus:ring-offset-blue-50"
            onClick={dismiss}
          >
            <span className="sr-only">Dismiss</span>
            <X className="h-5 w-5" aria-hidden="true" />
          </button>
        </div>
      </div>
    </div>
  );
}
